import { Link } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import { Brand } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PrintableCards } from "@/components/PrintableCards";
import { CARD_TOPICS, CARDS } from "@/lib/cards";
import { Nice } from "@/components/Nice";

export default function CardLibrary() {
  const all = Object.keys(CARDS).join(",");
  return (
    <div className="pp-app mode-kid" data-testid="card-library-page">
      <header className="pp-header">
        <Brand />
        <Link to="/" className="pp-ghost" data-testid="library-back-link"><ArrowLeft className="h-4 w-4" /> Back to <Nice /></Link>
      </header>
      <main className="pp-main pp-wide">
        <p className="pp-label">BurrHaus Counseling · card library</p>
        <h1 className="pp-h1">Every card, ready to post or print</h1>
        <p className="pp-sub max-w-xl">Share them with friends, print them for the fridge, or save them to your phone.</p>
        <nav className="pp-presets mt-6" data-testid="library-topic-nav">
          {CARD_TOPICS.map((t) => (
            <a key={t.id} href={`#topic-${t.id}`} className="pp-pill" data-testid={`library-jump-${t.id}`}>{t.title}</a>
          ))}
          <Link to={`/print/cards?cards=${all}`} target="_blank" className="pp-pill gold" data-testid="library-print-all">
            <Printer className="inline h-3.5 w-3.5 mr-1" /> Print every card
          </Link>
        </nav>
        {CARD_TOPICS.map((t) => (
          <div key={t.id} id={`topic-${t.id}`} className="scroll-mt-28" data-testid={`library-topic-${t.id}`}>
            <PrintableCards names={t.names} title={t.title} />
          </div>
        ))}
      </main>
      <Footer />
    </div>
  );
}
